import React from "react";
import ReactMarkdown from "react-markdown";   // ⬅ add this
import termsOfServiceContent from "./TermsOfService.json";
import "./Policies.scss";

export default function TermsOfService() {
  return (
    <div className="privacy-policy-container">
      <div className="privacy-main-heading privacy-heading">
        {termsOfServiceContent.title}
      </div>

      <div className="privacy-heading">{termsOfServiceContent.updated}</div>

      {/* render introduction safely with markdown */}
      <div className="privacy-para intro">
        <ReactMarkdown>{termsOfServiceContent.introduction}</ReactMarkdown>
      </div>

      {termsOfServiceContent.sections.map((section, index) => (
        <div key={index} className="section">
          <div className="privacy-heading">
            {`${index + 1}. ${section.title}`}
          </div>

          {section.subtitle && (
            <div className="privacy-sub-heading privacy-para">
              <ReactMarkdown>{section.subtitle}</ReactMarkdown>
            </div>
          )}

          {index >= 2 && index <= 6 ? (
            <ul className="privacy-section-content">
              {section.content.map((paragraph, idx) => (
                <li key={idx} className="privacy-para">
                  <ReactMarkdown>{paragraph}</ReactMarkdown>
                </li>
              ))}
            </ul>
          ) : (
            section.content.map((paragraph, idx) => (
              <div key={idx} className="privacy-para">
                <ReactMarkdown>{paragraph}</ReactMarkdown>
              </div>
            ))
          )}
        </div>
      ))}
    </div>
  );
}
